import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f06a3f1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-2 mt-2 order-attachment-grid attachment-border" }
const _hoisted_2 = {
  style: {"align-self":"center"},
  class: "mt-6"
}
const _hoisted_3 = { style: {"float":"right"} }
const _hoisted_4 = ["href", "download"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon fas fa-download is-small" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon fas fa-edit" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon fas fa-trash" }, null, -1))

import { ref } from "vue"
import Thumbnail from "@/components/common/Thumbnail.vue"
import DropZone from "@/components/admin/content/editor/DropZone.vue"

type Props = {
  fileName: string,
  contentUrl: string,
  canEdit: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'OrderAttachment',
  props: {
    fileName: {},
    contentUrl: {},
    canEdit: { type: Boolean }
  },
  emits: [ "delete","replace" ],
  setup(__props: any, { emit: __emit }) {

const fileUpload = ref<InstanceType<typeof DropZone> | null>(null)

const emit = __emit

const props = __props

function handleEdit() {
  fileUpload.value?.browse()
}

function handleFileReplace(file: File) {
  emit("replace", file)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(Thumbnail, {
      "thumbnail-url": _ctx.contentUrl,
      "thumbnail-type": "attachment",
      style: {"height":"128px","width":"128px"}
    }, null, 8, ["thumbnail-url"]),
    _createElementVNode("article", null, [
      _createElementVNode("h6", _hoisted_2, _toDisplayString(_ctx.fileName), 1),
      _createElementVNode("article", _hoisted_3, [
        _renderSlot(_ctx.$slots, "download", {}, () => [
          _createElementVNode("a", {
            href: _ctx.contentUrl,
            download: _ctx.fileName,
            class: "button mx-1",
            type: "button"
          }, [
            _hoisted_5,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("download")), 1)
          ], 8, _hoisted_4)
        ]),
        (_ctx.canEdit)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("button", {
                class: "button mx-1",
                "data-unit": "edit-trigger",
                onClick: handleEdit
              }, [
                _hoisted_6,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('edit')), 1)
              ]),
              _createElementVNode("button", {
                class: "button is-light is-danger mx-1",
                "data-unit": "delete-trigger",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('delete')))
              }, [
                _hoisted_7,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('delete')), 1)
              ])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _createVNode(DropZone, {
        ref_key: "fileUpload",
        ref: fileUpload,
        onChange: handleFileReplace
      }, null, 512)
    ])
  ]))
}
}

})